import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//openTok components
import { OpenTokComponent } from './open-tok.component';
import { PublisherComponent } from './publisher/publisher.component';
import { SubscriberComponent } from './subscriber/subscriber.component';
import { ChatBoxComponent } from './chat-box/chat-box.component';

const openTok = [OpenTokComponent, PublisherComponent, SubscriberComponent, ChatBoxComponent];

//services
import { OpenTokService } from '../open-tok/services/open-tok.service';

const services = [OpenTokService];

//material modules
import {
    MatInputModule, MatButtonModule, MatCardModule,
    MatTabsModule, MatMenuModule, MatDialogModule,
    MatSlideToggleModule, MatSelectModule, MatCheckboxModule,
    MatDatepickerModule, MatExpansionModule, MatChipsModule, MatAutocompleteModule, MatProgressSpinnerModule, MatTooltipModule, MatChipInputEvent, MatPaginatorModule
} from '@angular/material';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
const MaterialModules = [MatInputModule, MatButtonModule, MatCardModule,
    MatTabsModule, MatMenuModule, MatDialogModule,
    MatSlideToggleModule, MatSelectModule, MatCheckboxModule,
    MatDatepickerModule, MatMomentDateModule, MatExpansionModule,
    MatChipsModule, MatSnackBarModule, MatAutocompleteModule, MatProgressSpinnerModule, MatTooltipModule, MatPaginatorModule];

//Meta data of modules
@NgModule({
    declarations: [openTok],
    imports: [
        CommonModule,
        ...MaterialModules
    ],
    providers: [...services],
    exports: [OpenTokComponent]
})
export class OpenTokModule { }


// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/open-tok/index.ts